import { format, parse } from "date-fns";

import { WorkHistoryEmployment } from "./WorkHistoryList";

const parseEmploymentDate = (date: string): Date => parse(date, "yyyy-MM-dd", new Date());

/**
 * CV order of the identity cards' "See work history" expander: most recent
 * employment first. Unparsable dates keep their relative order.
 */
export const sortEmploymentsMostRecentFirst = <T extends WorkHistoryEmployment>(
	employments: T[]
): T[] =>
	[...employments].sort((a, b) => {
		try {
			if (!a.startedAt || !b.startedAt) {
				return 0;
			}

			return parseEmploymentDate(a.startedAt) > parseEmploymentDate(b.startedAt) ? -1 : 1;
		} catch {
			return 0;
		}
	});

/**
 * "Jan 2019 - Present" range of the current (most recent) employment, shown
 * after the role in the person identity card. Empty when no dated employment.
 */
export const formatCurrentEmploymentDateRange = (
	sortedEmployments: WorkHistoryEmployment[]
): string => {
	const current = sortedEmployments[0];

	if (!current?.startedAt) {
		return "";
	}

	const startedAt = format(parseEmploymentDate(current.startedAt), "MMM yyyy");
	const endedAt = current.endedAt
		? format(parseEmploymentDate(current.endedAt), "MMM yyyy")
		: "Present";

	return `${startedAt} - ${endedAt}`;
};
